import React, { useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import { Spinner, Alert, AlertIcon, useMediaQuery } from "@chakra-ui/react";
import BGLogin from "./assets/images/image_login.png";
import LogoImg from "./assets/images/Logo-PNG.png";
import OpenEyeImg from "./assets/images/open_eye.png";
import CloseEyeImg from "./assets/images/close_eye.png";
import UserIconImg from "./assets/images/lucide_user-round.png";
import PasswordIconImg from "./assets/images/mdi_password-outline.png";
import LogoFooterImg from "./assets/images/logo_footer.png";
import UserContext from "../State/UserContext";

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [LoginStatusAlert, setLoginStatusAlert] = useState(null);
    const history = useHistory();
    const { setUser } = useContext(UserContext);
    const [showImagePanel] = useMediaQuery("(min-width: 769px)");

    async function login() {
        if (!email || !password) {
            setLoginStatusAlert(
                <Alert status="warning" borderRadius="5px">
                    <AlertIcon />
                    Por favor ingrese los datos
                </Alert>
            );
            return;
        }
        setLoading(true);
        setLoginStatusAlert(null);
        try {
            var body = {
                email: email,
                password: password,
            };
            var response = await fetch("user/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
            });
            var jsonRes = await response.json();

            switch (jsonRes.error) {
                case false:
                    setUser(jsonRes.data);
                    history.push("/Socios");
                    setLoading(false);
                    break;
                case true:
                    setLoginStatusAlert(
                        <Alert status="warning" borderRadius="5px">
                            <AlertIcon />
                            {jsonRes.message}
                        </Alert>
                    );
                    break;
                default:
                    break;
            }
        } catch {
            setLoginStatusAlert(
                <Alert status="warning" borderRadius="5px">
                    <AlertIcon />
                    No se pudo iniciar sesión intente de nuevo porfavor.
                </Alert>
            );
        }
        setLoading(false);
    }

    return (
        <div style={{ display: "flex", minHeight: "100vh", fontFamily: "Arial, sans-serif" }}>
            <style>{`.login-input { text-align: center; }.login-input::placeholder { text-align: center; }`}</style>
            {/* Left side - Login form */}
            <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between", padding: "40px 60px", background: "#fff" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", maxWidth: 500, margin: "0 auto", width: "100%", paddingTop: 100 }}>
                    {/* Logo */}
                    <div style={{ textAlign: "center", marginBottom: 45 }}>
                        <img src={LogoImg} alt="Hospital Británico" style={{ maxHeight: 80, width: "auto" }} />
                    </div>

                    {/* Title */}
                    <h1 style={{ fontWeight: 600, fontSize: 24, lineHeight: "24px", letterSpacing: "0%", textAlign: "center", color: "#004890", marginBottom: 45 }}>Iniciar Sesión</h1>

                    {/* Register link */}
                    <p style={{ color: "#666", fontSize: 14, marginBottom: 45 }}>
                        ¿No tienes una cuenta? Regístrese{" "}
                        <Link to="/Register" style={{ color: "#06ACCD", fontWeight: 'bold', }}>aquí</Link>
                    </p>

                    {/* Email input */}
                    <div style={{ width: "100%", marginBottom: 16, position: "relative" }}>
                        <div style={{ display: "flex", alignItems: "center", border: "1px solid rgba(98, 134, 172, 0.5)", borderRadius: 8, padding: "12px 16px", background: "#fff" }}>
                            <img src={UserIconImg} alt="" style={{ width: 20, height: 20, marginRight: 12, flexShrink: 0 }} />
                            <input
                                className="login-input"
                                type="email"
                                placeholder="E-mail"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                style={{ border: "none", outline: "none", flex: 1, fontSize: 15, color: "#333", background: "transparent", textAlign: "center" }}
                            />
                        </div>
                    </div>

                    {/* Password input */}
                    <div style={{ width: "100%", marginBottom: 20, position: "relative" }}>
                        <div style={{ display: "flex", alignItems: "center", border: "1px solid rgba(98, 134, 172, 0.5)", borderRadius: 8, padding: "12px 16px", background: "#fff" }}>
                            <img src={PasswordIconImg} alt="" style={{ width: 20, height: 20, marginRight: 12, flexShrink: 0 }} />
                            <input
                                className="login-input"
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                style={{ border: "none", outline: "none", flex: 1, fontSize: 15, color: "#333", background: "transparent", textAlign: "center" }}
                            />
                            {showPassword ? (
                                <img src={OpenEyeImg} alt="Ocultar contraseña" style={{ width: 20, height: 20, cursor: "pointer", flexShrink: 0 }} onClick={() => setShowPassword(false)} />
                            ) : (
                                <img src={CloseEyeImg} alt="Mostrar contraseña" style={{ width: 20, height: 20, cursor: "pointer", flexShrink: 0 }} onClick={() => setShowPassword(true)} />
                            )}
                        </div>
                    </div>

                    {/* Alert */}
                    {LoginStatusAlert && <div style={{ width: "100%", marginBottom: 16 }}>{LoginStatusAlert}</div>}

                    {/* Login button */}
                    <button
                        type="button"
                        onClick={login}
                        disabled={loading}
                        style={{
                            width: "100%",
                            padding: "14px",
                            background: "#004890",
                            color: "#fff",
                            border: "none",
                            borderRadius: 8,
                            fontSize: 16,
                            fontWeight: 600,
                            cursor: loading ? "not-allowed" : "pointer",
                            marginBottom: 30,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 8,
                        }}
                    >
                        {loading ? <Spinner size="sm" color="white" /> : "Ingresar"}
                    </button>

                    {/* Forgot password */}
                    <Link to="/ForgotPassword" style={{ color: "#004890", fontSize: 14 }}>
                        Olvidé mi contraseña
                    </Link>
                </div>

                {/* Footer */}
                <div style={{ textAlign: "center", padding: "20px 0", fontSize: 13, color: "#999", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                    <img src={LogoFooterImg} alt="Hospital Británico" style={{ height: 14, width: 35 }} />
                    <span>Hospital Británico | © 2025</span>
                </div>
            </div>

            {/* Right side - Image (oculto en tablet y móvil) */}
            {showImagePanel && (
                <div style={{ flex: 1, position: "relative", overflow: "hidden", display: "flex", flexDirection: "column" }}>
                    <img
                        src={BGLogin}
                        alt="Portal de prestadores"
                        style={{ width: "100%", height: "100%", position: "fixed" }}
                    />
                    {/* Overlay text at bottom */}
                    <div
                        style={{
                            position: "absolute",
                            bottom: 150,
                            left: 0,
                            right: 0,
                            background: "linear-gradient(180deg, #020A14,#395D84 )",
                            padding: "40px 50px",
                            color: "#fff",
                            textAlign: "center",
                            opacity: 0.6,
                        }}
                    >
                        <h2 style={{ fontWeight: 600, fontSize: "39.84px", lineHeight: "48px", letterSpacing: 0, textAlign: "center", color: "#FFFFFF", marginBottom: 10 }}>
                            Bienvenido al portal de <br /> prestadores
                        </h2>
                        <p style={{ fontWeight: 600, fontSize: "19.84px", lineHeight: "24px", letterSpacing: "0%", textAlign: "center", verticalAlign: "middle", opacity: 0.9 }}>
                            Donde podrás Realiza tus tramites y gestiones online
                            <br />
                            de manera sencilla.
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
}
